(ns minorodata.sql-console.model
  (:require [mold.core :as m :include-macros true]
            [minorodata.users.model :refer [searchable-user]]))

(declare ->sql-query
         ->sql-metadata-partial
         ->sql-editor
         ->sql-query-history
         ->sql-query-favourites
         ->sql-metadata)

(m/defmodel sql-query
  {:sql-query-id    [::m/identity ::m/req ::m/string "Uniq id"]
   :parent-id       [::m/string ::m/nilable "Parent query id"]
   :client-id       [::m/string "Client id"]
   :updated-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :created-by      {::m/type     ::m/ref
                     ::m/ref-type searchable-user
                     ::m/doc      "Related user"}
   :updated-at      [::m/string "Updated date"]
   :created-at      [::m/string "Created date"]
   ;; meta
   :name            [::m/string ::m/nilable "SQL query name"]
   :description     [::m/string ::m/nilable "SQL query description"]
   :command         [::m/string "Original SQL"]
   :favourite       [::m/bool "Has the query been favourited"]

   :order           [::m/number ::m/nilable "UI only field to preserve the display order"]})


(m/defmodel sql-metadata
  {:completions ["Autocompletions"]
   :tree        ["Nodes for tree view"]
   :loaded      [::m/bool "Data loaded from the server"]
   :processed   [::m/bool "If the data has been processed by the webworker"]}
  {:singleton true})

(m/defmodel sql-metadata-partial
  {:params   [::m/identity ::m/req ::m/map "Params used to request"]
   :metadata ["Returned metadata"]})

(m/defmodel sql-editor
  {:tab-count           [::m/number "Number of open tabs"]
   :current-tab         [::m/number "Current tab idx"]

   :tab-data-container  [::m/vector "A vector of data for tabs"]

   ;;  for removal
   :code                [::m/string "Editor value"]
   ;;  for removal
   :skip-value-updates  [::m/bool "Make editor ignore value prop changes"]
   ;;  for removal
   :data                [::m/vector ::m/nilable "Vector of results"]
   :data-preview-height [::m/number ::m/nilable "Height of data preview window"]
   :sidebar-width       [::m/number ::m/nilable "Width of the sidebar"]
   :editor-height       [::m/number ::m/nilable "Editor height"]
   ; :metadata            ["Random metadata"]

   :sidebar-tab         [::m/string ::m/nilable "Current sidebar tab"]
   ;;  for move inside tdc
   :results-tab         [::m/number "Currently selected results tab"]
   ;;  for move inside tdc
   :results-tab-configs [::m/map "A map of configurations"]
   ;;  for move inside tdc
   :error-message       [::m/string ::m/nilable "Error message"]
   ;;  for move inside tdc
   :failed?             [::m/bool ::m/nilable "status of the last request"]

   :selection           [::m/string "Current selection"]

   :selection-validity  [::m/keyword "Used to show current selection status"]
   ;;  for move inside tdc
   :query-duration      [::m/number "How long it took to complete the query in ms"]
   ;;  for move inside tdc
   :query-start-time    [::m/string "Timestamp of when the query was initiated"]

   :history-query-params    [::m/map "History request query params"]
   :favourites-query-params [::m/map "Favourites request query params"]

   :sql-query-to-edit [::m/string ::m/nilable "SQL Query history entry to edit"]

   :history-tab         {::m/req  false
                         ::m/nilable true
                         ::m/type ::m/enum
                         ::m/vals #{:history :favorites}
                         ::m/doc  "Current history view"}

   :groups-for-transform          [::m/vector "An array of groups"]
   :create-transform-drawer-open? [::m/bool ::m/nilable "Is create transform drawer open?"]
   :create-data-view-modal-open?  [::m/bool ::m/nilable "Is create data view modal open?"]
   :rename-query-modal-open?      [::m/bool ::m/nilable "Is rename statement modal open?"]
   :data-view-name                [::m/string ::m/nilable "Create data view input name"]
   :max-rows-count                [::m/number "Maximum number of rows returned by query"]}
  {:singleton true})


(m/defmodel sql-query-history
  {:queries {::m/type        ::m/ref
             ::m/cardinality ::m/many
             ::m/ref-type    sql-query
             ::m/doc         "Link to query"}
   :total-pages        [::m/number]
   :page               [::m/number]
   :items-per-page     [::m/number]
   :order-by           [::m/keyword]
   :order-dir          [::m/keyword]
   :latest-order-index [::m/number ::m/nilable]}
  {:singleton true})


(m/defmodel sql-query-favourites
  {:queries {::m/type        ::m/ref
             ::m/cardinality ::m/many
             ::m/ref-type    sql-query
             ::m/doc         "Link to query"}
   :total-pages        [::m/number]
   :page               [::m/number]
   :items-per-page     [::m/number]
   :order-by           [::m/keyword]
   :order-dir          [::m/keyword]
   :latest-order-index [::m/number ::m/nilable]}
  {:singleton true})
